module.exports = __webpack_public_path__ + "img/gastronomia.e216b52e.svg";